import { z } from 'zod'

export const AGENTMCP_CONTEXT_READ_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpContextResponseSchema = z.object({
  user: z.object({
    id: z.number(),
    email: z.string(),
  }).passthrough(),
}).passthrough()

export type AgentmcpContextResponse = z.infer<typeof agentmcpContextResponseSchema>
